export default __webpack_public_path__ + "static/media/team_xl.c1c92ca4.jpg";